export default __webpack_public_path__ + "static/media/mongodb.eb0572a9.png";